if (!customElements.get("popup-overlay")) {
  customElements.define(
    "popup-overlay",
    class PopupOverlay extends ModalDialog {
      constructor() {
        super();
        this.delay = parseInt(this.dataset.delay, 10) * 1000;
        this.id = this.getAttribute("id");
        this.moved = true;
      }

      connectedCallback() {
        if (
          localStorage.getItem(this.id) !== "dismissed" &&
          !Shopify.designMode
        ) {
          setTimeout(() => {
            this.show();
          }, this.delay);
        }

        // Add event listener to close popup when button clicked
        this.addEventListener("click", (event) => {
          const target = event.target.closest("[data-close-popup]");
          if (target) {
            event.preventDefault(); // Prevent navigation if needed
            this.hide();
            // Optional: if you still want the link to follow through after hiding, do it here
            // const href = target.getAttribute('href');
            // if (href && href !== '#') {
            // 	window.location.href = href;
            // }
          }
        });

        return super.connectedCallback();
      }

      show() {
        super.show();
        document.body.classList.remove("overflow-hidden");
        const event = new CustomEvent("popup-overlay:open", {
          detail: {
            id: this.id,
          },
        });
        document.dispatchEvent(event);
      }

      hide() {
        super.hide();

        const event = new CustomEvent("popup-overlay:close", {
          detail: {
            id: this.id,
          },
        });
        document.dispatchEvent(event);

        if (!Shopify.designMode) {
          localStorage.setItem(this.id, "dismissed");
        }
      }
    }
  );
}
